import { Directive, ViewContainerRef, ContentChildren } from '@angular/core';
import { ComplexBase, ArrayBase, setValue } from '@syncfusion/ej2-angular-base';



let /** @type {?} */ input: string[] = ['disabled', 'iconCss', 'id', 'separator', 'text', 'url'];
let /** @type {?} */ outputs: string[] = [];
export class SplitButtonItemDirective extends ComplexBase<SplitButtonItemDirective> {
public directivePropList: any;
/**
 * Used to enable or disable the item.
 * \@default false
 */
public disabled: any;
/**
 * Defines class/multiple classes separated by a space for the item that is used to include an icon. 
 * Action item can include font icon and sprite image.
 * \@default ''
 */
public iconCss: any;
/**
 * Specifies the id for item.
 * \@default ''
 */
public id: any;
/**
 * Specifies separator between the items. Separator are horizontal lines used to group action items.
 * \@default false
 */
public separator: any;
/**
 * Specifies text for item.
 * \@default ''
 */
public text: any;
/**
 * Specifies url for item that creates the anchor link to navigate to the url provided.
 * \@default ''
 */
public url: any;
/**
 * @param {?} viewContainerRef
 */
constructor(private viewContainerRef:ViewContainerRef) {
        super();
        setValue('currentInstance', this, this.viewContainerRef);
        this.registerEvents(outputs);
        this.directivePropList = input;
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: 'e-splitbuttonitems>e-splitbuttonitem',
    inputs: input,
    outputs: outputs,    
    queries: {

    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ViewContainerRef, },
];
}

function SplitButtonItemDirective_tsickle_Closure_declarations() {
/** @type {?} */
SplitButtonItemDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SplitButtonItemDirective.ctorParameters;
/** @type {?} */
SplitButtonItemDirective.prototype.directivePropList;
/**
 * Used to enable or disable the item.
 * \@default false
 * @type {?}
 */
SplitButtonItemDirective.prototype.disabled;
/**
 * Defines class/multiple classes separated by a space for the item that is used to include an icon. 
 * Action item can include font icon and sprite image.
 * \@default ''
 * @type {?}
 */
SplitButtonItemDirective.prototype.iconCss;
/**
 * Specifies the id for item.
 * \@default ''
 * @type {?}
 */
SplitButtonItemDirective.prototype.id;
/**
 * Specifies separator between the items. Separator are horizontal lines used to group action items.
 * \@default false
 * @type {?}
 */
SplitButtonItemDirective.prototype.separator;
/**
 * Specifies text for item.
 * \@default ''
 * @type {?}
 */
SplitButtonItemDirective.prototype.text;
/**
 * Specifies url for item that creates the anchor link to navigate to the url provided.
 * \@default ''
 * @type {?}
 */
SplitButtonItemDirective.prototype.url;
/** @type {?} */
SplitButtonItemDirective.prototype.viewContainerRef;
}

/**
 * SplitButtonItem Array Directive
 */
export class SplitButtonItemsDirective extends ArrayBase<SplitButtonItemsDirective> {
constructor() {
        super('items');
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: 'ejs-splitbutton>e-splitbuttonitems',
    queries: {
        children: new ContentChildren(SplitButtonItemDirective)
    },
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function SplitButtonItemsDirective_tsickle_Closure_declarations() {
/** @type {?} */
SplitButtonItemsDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SplitButtonItemsDirective.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
